'use strict';
const Ajax = require('common/infra/ajax');
const $ = require('jquery');

class API {
    constructor() {
    }

    getURIObject(uri) {
        const path = `/api/uri-object?uri=${encodeURIComponent(uri)}`;
        return Ajax.GET(path)
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./data/infra/api/object/index.js